import { useGetQuotingProspectsId } from 'utils/web_api'
import type { QuotingProspect } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { type MetadataConfiguration } from '../types'
import { resolveNextStepPath } from '../utils'
import CreateOrUpdateProspect, { type CreateOrUpdateProspectProps } from './CreateOrUpdateProspect'

type Props = Omit<CreateOrUpdateProspectProps, 'onSuccess'> & {
  prospectId: string
  nextStepPath: string
  metadataConfiguration: MetadataConfiguration
}

export function EditProspect ({ prospectId, nextStepPath, ...props }: Props) {
  const { assign } = useWindowLocation()

  const { data: prospect, isFetched } = useGetQuotingProspectsId(prospectId)

  const onSuccess = (prospect: QuotingProspect) => {
    const path = resolveNextStepPath(nextStepPath, prospect.id)
    assign(path)
  }

  return (
    <div className='flex justify-center'>
      {isFetched && <CreateOrUpdateProspect {...props} prospect={prospect} onSuccess={onSuccess} />}
    </div>
  )
}

export default (props: Props) => {
  return (
    <EditProspect {...props} />
  )
}
